/**
 * The screen the Booking Management Page gate renders. It is driven by the
 * booking fetch lifecycle (see the bookingManagement middleware) plus the
 * user-driven transitions inside the gate (OtpVerification to SignIn and back).
 */
export enum BookingManagementStage {
  Loading = 'Loading',
  Granted = 'Granted',
  OtpPreSend = 'OtpPreSend',
  OtpVerification = 'OtpVerification',
  OtpExpired = 'OtpExpired',
  SignIn = 'SignIn',
  AccessDenied = 'AccessDenied',
  NotFound = 'NotFound',
  Error = 'Error'
}
